// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal__BjexXFRDZF{width:450px}`, "",{"version":3,"sources":["webpack://./src/app/components/appModals/components/desktopAppNoticeModal/desktopAppNoticeModal.module.scss"],"names":[],"mappings":"AAAA,mBACE,WAAA","sourcesContent":[".modal {\n  width: 450px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `modal__BjexXFRDZF`
};
export default ___CSS_LOADER_EXPORT___;
